// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32BGH","rootNoMargin":"styles_rootNoMargin__3f_Qy"};